import {ClsErrores2} from './cls-errores';

export class ClsCostoHorarios {
  IdPresupuesto?: bigint;
  IdCatalogoCostoHorario: bigint;
  CalculoDetallado: boolean;
  CantidadCombustible: number;
  CantidadLubricante: number;
  Capacidad?: string;
  Ccarter: number;
  Disponibilidad?: string;
  Faceite: number;
  Factcomb: number;
  FactFuentes: number;
  Foper: number;
  Ha: number;
  Hllantas: number;
  Horasc: number;
  HPiezas: number;
  IdCatalogoAcei: bigint;
  IdCatalogoCF?: bigint;
  IdCatalogoComb: bigint;
  IdCatalogoE: bigint;
  IdCatalogoLla: bigint;
  IdCatalogoOtrasFuentes: bigint;
  IdCatalogoPza: bigint;
  IdCatalogoR: bigint;
  IdCatalogoVa: bigint;
  Marca?: string;
  Modelo?: string;
  NumSerie?: string;
  Potencia?: number;
  Propietario?: string;
  ProponerCodigos?: boolean;
  Q: number;
  S: number;
  TipoCombustible?: number;
  Ubicacion?: string;
  UnidadPotencia?: string;
  ValorComercial?: number;
  Ve: number;
  VidaUtil?: string;
  Vr: number;
  TasaInteresMoneda1: number;
  TasaInteresMoneda2: number;
  JsonCostosHorariosMO?: string;
  LsCostosHorariosMO?: ClsLsJsonCostosHorariosMO[];
  JsonCostosHorariosOC?: string;
  LsCostosHorariosOC?: ClsLsJsonCostosHorariosOC[];
  // variables para el detalle de maquinaria
  CostoActivo?: number;
  CostoOperacion?: number;
  CostoConsumos?: number;
  CostoActivoTotal?: number;
}

export class ClsLsJsonCostosHorariosMO {
  IdCatalogoCostoHorario?: bigint;
  IdCatalogoMO: bigint;
  Renglon: number;
  Volumen: number;
}

export class ClsLsJsonCostosHorariosOC {
  IdCatalogoCostoHorario?: bigint;
  IdCatalogoOC: bigint;
  Renglon: number;
  Volumen: number;
}

export class ClsLsJsonCostosHorariosTI {
  IdCatalogoTI?: bigint;
  TasaInteresMoneda1: number;
  TasaInteresMoneda2: number;
  TasaInteresMoneda3: number;
}

export class ClsLsJsonCatalogoCostosEQ {
  IdCatalogoEQ?: bigint;
  CostoCFMoneda1: number;
  CostoCOMoneda1: number;
  CostoMOMoneda1: number;
  CostoCFMoneda2: number;
  CostoCOMoneda2: number;
  CostoMOMoneda2: number;
  CostoCFMoneda3: number;
  CostoCOMoneda3: number;
  CostoMOMoneda3: number;
}

export class ClsGenerarCHBase64 {
  costosHorariosPDF: string;
  costosHorariosXlS: string;
  costosHorariosXlSX: string;
  errores: ClsErrores2;
}
